<script>
import Layout from "../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import api from "@/api/";
import Swal from "sweetalert2";
import {filter} from "../../helpers/Vue-Filter";
import Loader from "../../components/widgets/loader.vue";
import Pagination from "../../components/widgets/pagination.vue";
import Add from "./add.vue";
import Edit from "./edit.vue"
import {mixin} from "../../helpers/Vue-Mixin";
import {startTiming, stopTiming} from "@/helpers/Timer";
import moment from "moment";

export default {
  /* eslint-disable no-console */

  filters: {
    ...filter,
  },

  mixins: [mixin],

  page: {
    title: "通知",
    meta: [{name: "description", content: appConfig.description}],
  },

  components: {Layout, PageHeader, Loader, Add, Pagination, Edit},

  data() {
    return {
      breadcrumb: [
        {
          text: "通知",
          href: "/admin/notifications",
          active: true,
        },
      ],
      loading: false,
      showCreateModal: false,
      showEditModal: false,
      pagination: {
        current_page: 1,
        total: 20,
        per_page: 20,
      },
      notifications: [],
      lastLoadedTime: null,
      dataEdit: {},
    };
  },

  created() {
    this.getList();
    const formattedDate = moment().format('YYYY/MM/DD HH:mm:ss');
    localStorage.setItem('lastLoadedTime', formattedDate);
    this.lastLoadedTime = localStorage.getItem('lastLoadedTime');
  },

  watch: {},

  computed: {
    theme() {
      return this.$store.state.theme;
    },

    fields() {
      return [
        {
          key: "title",
          label: "タイトル",
          class: "text-start align-middle tilte-column",
        },
        {
          key: "message",
          label: "内容",
          class: "text-start align-middle tilte-column",
        },
        {
          key: "user_type",
          label: "配信先",
          class: "text-start align-middle tilte-column",
        },
        {
          key: "type",
          label: "区分",
          class: "text-start align-middle tilte-column",
        },
        {
          key: "status",
          label: "ステータス",
          class: "text-start align-middle tilte-column",
        },
        {
          key: "created_at",
          label: "作成日",
          class: "text-center align-middle tilte-column",
        },
        {
          key: "updated_at",
          label: "更新日",
          class: "text-center align-middle tilte-column",
        },
        {
          key: "actions",
          label: "操作",
          class: "text-center align-middle tilte-column",
        },
      ];
    },
  },

  methods: {

    changePage(newPage) {
      this.pagination.current_page = newPage;
      this.getList(newPage);
    },

    openCreateModal() {
      this.showCreateModal = true;
    },
    closeCreateModal() {
      this.showCreateModal = false;
    },
    async handleCreateNotification(newNotification) {
      this.closeCreateModal();

      await this.create(newNotification);
    },
    closeEditModal() {
      this.dataEdit = {};
      this.showEditModal = false;
    },
    async handleEditNotification(notification) {
      await this.edit(notification);
      this.closeEditModal();
    },
    async getList(page) {
      const startAt = startTiming(() => this.loading = true);
      try {
        const res = await api.paginateNotifications(page);

        this.notifications = res.data.data;
        this.pagination = res.data.meta;
      } catch (error) {
        console.log(error);

        window.toastr.error(error.response.status);
      } finally {
        stopTiming(startAt, 2000, () => this.loading = false);
      }

      this.loading = false;
    },
    async create(newNotification) {
      const startAt = startTiming(() => this.loading = true);
      try {
        await api.createNotification(newNotification);
        await this.getList();

      } catch (error) {
        console.log(error);

        window.toastr.error(error.response.status);
      } finally {
        stopTiming(startAt, 2000, () => this.loading = false);
      }

      this.loading = false;
    },
    async handlerEdit(id) {
      try {
        this.showEditModal = true;
        this.dataEdit = this.notifications.find(item => item.id === id);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
    async edit(notification) {
      const startAt = startTiming(() => this.loading = true);
      try {
        await api.editNotification(notification);
        await this.getList();

      } catch (error) {
        console.log(error);

        window.toastr.error(error.response.status);
      } finally {
        stopTiming(startAt, 2000, () => this.loading = false);
      }

      this.loading = false;
    },
    async destroy(id) {
      this.confirm(
        {
          title: "",
          text: "このデータを削除しますか？",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#395299",
          cancelButtonColor: "#FF5858",
          confirmButtonText: "はい",
          cancelButtonText: "いいえ",
        },
        async (e) => {
          if (e.isConfirmed) {
            const res = await api.deleteNotification(id);

            if (res.status === 200) {
              await this.getList();
            }
          }
        }
      );
    },
    userTypeLabel(key) {
      const map = {
        normal: 'くるあユーザー',
        plus: 'くるあプラスユーザー',
        all: '全員',
        facility: '施設'
      };

      return map[key];
    },
    notificationTypeLabel(key) {
      const map = {
        immediate: '今すぐ',
        scheduled: '後で送信',
        periodic: '定期的に'
      };

      return map[key];
    },
    statusLabel(key) {
      const map = {
        1: '有効',
        0: '無効',
      };

      return map[key];
    },

    reloadPage() {
      window.location.reload();
    },
  },
};
</script>

<template>
  <div :id="theme">
  <Layout class="kurua-page">
    <div class="col-12 d-flex justify-content-between align-items-center mt-md-1 mb-md-n4 mt-lg-4 mb-lg-1 mt-xl-1 mb-xl-2">
      <div class="col-12 mt-md-n5 mt-lg-n4 mt-xl-0">
        <PageHeader :items="breadcrumb" theme="admin" fontSize="28px" fontWeight="700 !important" @showModalAdd="openCreateModal" :titleButtonAdd="'新規作成'" :showAdd="true" title="可動域評価" />
      </div>
      <!-- <div class="position-absolute mt-lg-n4 d-flex" style="margin-left: 4rem; margin-top: -2rem;">
        <button @click="reloadPage" class="custom-button">
          <img src="@/assets/images/icon/icon-reload.svg" alt="" style="width: 20px; height: 20px;" />
            更新
        </button>
        <div class="ml-1">
          <p style="margin: 0; padding-right: 10px; font-size: 14px;">最終更新日時:</p>
          <p style="margin: 0; padding-right: 10px; font-size: 14px; margin-top: -5px;">{{ lastLoadedTime }}</p>
        </div>
      </div> -->
    </div>

    <Add :showModal="showCreateModal" @close="closeCreateModal" @create="handleCreateNotification" theme="admin" />
    <Edit lazy :showModal="showEditModal" @edit="handleEditNotification" @close="closeEditModal" :data="dataEdit"/>

    <div class="mb-0" style="min-height: 80vh !important">
      <Loader :loading="loading" theme="plus">

        <div class="col-12">
          <b-table :items="notifications" :fields="fields" sort-icon-left hover outlined thead-class="sticky-top text-center bg-table-lyg" sticky-header style="min-height: 75vh;" responsive="sm">
            <template #cell(user_type)="row">
              {{ userTypeLabel(row.item.user_type) }}
            </template>
            <template #cell(type)="row">
              {{ notificationTypeLabel(row.item.type) }}
            </template>
            <template #cell(status)="row">
              {{ statusLabel(row.item.status) }}
            </template>
            <template #cell(created_at)="row">
              {{ row.item.created_at | fomatDate2 }}
            </template>
            <template #cell(updated_at)="row">
              {{ row.item.updated_at | fomatDate2 }}
            </template>
            <template #cell(actions)="row">
              <ul class="list-inline font-size-20 contact-links mb-0" style="min-width: 100px;">
                <li title="編集" class="list-inline-item px-2"
                  @click=handlerEdit(row.item.id)>
                  <a>
                    <img src="@/assets/images/icon/icon-changes.svg" alt="" style="width: 28px; height: 28px; margin-top: -0.5rem; cursor: pointer;" />
                  </a>
                </li>
                <li title="削除" @click="destroy(row.item.id)" class="list-inline-item px-2">
                  <a class="pointer">
                    <i class="bx bx-trash text-white bg-danger p-1" style="border-radius: 50%; cursor: pointer"></i>
                  </a>
                </li>
              </ul>
            </template>
          </b-table>
        </div>
        <div class="d-flex justify-content-center text-center mt-5" v-if="notifications.length === 0">
          <div class="undefine">
            <img src="@/assets/images/no-data.jpg" alt="" />
            <div class="mt-3">詳細データはありません。</div>
          </div>
        </div>

        <Pagination :paging="pagination" @change="changePage" label="通知件数：" unitLabel="件"/>
      </Loader>
    </div>
  </Layout>
  </div>
</template>

<style lang="scss" scoped>
.b-table-sticky-header {
  max-height: 65vh;
}

.b-table-sticky-header {
  max-height: 65vh;
}
::v-deep th {
  text-align: center !important;

  div {
    min-width: 140px;
  }
}
</style>
